import browseActionConstants from '../constants/browseActionConstants';

const initialState = {
  openingsList: [],
  orgJobs: [],
  openingDetails: {},
  searchOpeningDetails: [],
  paginationInfo: {},
  sortby: '',
  isLoadingOpeningList: false,
  isLoadingSearchList: false,
  isLoadingOrgJobs: true,
  isLoadingOpeningDetails: false,
  isLoadingJobOpeningDetails: false,
  fetchMoreJobsLoading: false,
  currentRequestId: null,
  openingDetailRequestId: null,
};

const browseReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case browseActionConstants.SET_REQUEST_ID:
      return {
        ...state,
        currentRequestId: action.requestId,
      };
    case browseActionConstants.SET_OPENING_DETAIL_REQUEST_ID:
      return {
        ...state,
        openingDetailRequestId: action.requestId,
      };
    case browseActionConstants.GET_OPENINGS_SUCCESS:
      if (state.currentRequestId !== action.requestId) {
        return state;
      }
      return {
        ...state,
        openingsList: action.payload.jobs,
        paginationInfo: action.payload.page_info,
        currentRequestId: null,
      };
    case browseActionConstants.RESET_OPENINGS:
      return {
        ...state,
        openingsList: [],
      };
    case browseActionConstants.FETCH_NEXT_OPENINGS:
      return {
        ...state,
        openingsList: [...state.openingsList, ...action.payload.jobs],
        paginationInfo: action.payload.page_info,
      };
    case browseActionConstants.GET_OPENINGS_DETAILS:
      if (state.openingDetailRequestId !== action.requestId) {
        return state;
      }
      return {
        ...state,
        openingDetails: action.payload,
        openingDetailRequestId: null,
        isLoadingJobOpeningDetails: false,
      };
    case browseActionConstants.SET_MORE_JOBS_LOADING_ON:
      return {
        ...state,
        fetchMoreJobsLoading: true,
      };
    case browseActionConstants.SET_MORE_JOBS_LOADING_OFF:
      return {
        ...state,
        fetchMoreJobsLoading: false,
      };
    case browseActionConstants.GET_SEARCH_OPENINGS_LOADING_ON:
      return {
        ...state,
        isLoadingSearchList: true,
      };
    case browseActionConstants.GET_SEARCH_OPENINGS_LOADING_OFF:
      return {
        ...state,
        isLoadingSearchList: false,
      };
    case browseActionConstants.GET_SEARCH_OPENINGS_SUCCESS:
      return {
        ...state,
        searchOpeningDetails: action.payload.jobs,
      };
    case browseActionConstants.SET_OPENING_LIST_LOADING_ON:
      return {
        ...state,
        isLoadingOpeningList: true,
        isLoadingOrgJobs: true,
      };
    case browseActionConstants.SET_OPENING_LIST_LOADING_OFF:
      return {
        ...state,
        isLoadingOpeningList: false,
        isLoadingOrgJobs: false,
      };

    case browseActionConstants.SET_OPENING_DETAILS_LOADING_ON:
      return {
        ...state,
        isLoadingOpeningDetails: true,
      };
    case browseActionConstants.SET_OPENING_DETAILS_LOADING_OFF:
      return {
        ...state,
        isLoadingOpeningDetails: false,
        isLoadingJobOpeningDetails: true,
      };
    case browseActionConstants.SET_SORTBY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default browseReducer;
